module.exports = __webpack_public_path__ + "assets/img/bl-big-02.eb8eaeff.jpg";